import { createSelector } from 'reselect';

// Config
import supportedCreditCardTypes from '../../../constants/supportedCreditCardTypes';
import { getCardTypeNameSelector } from '../../../redux/reducers/payment/cardTypeSelector';

const cardDetailsState = createSelector(
  [getCardTypeNameSelector, (_state, prepaidCard) => prepaidCard],
  (cardTypeName, prepaidCard) => ({
    canSave: cardTypeName !== supportedCreditCardTypes.BUSINESS_ACCOUNT && !prepaidCard,
  }),
);

export default cardDetailsState;
